import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { authorize } from './authThunk';
import { IAuthResponse, IAuthState } from './types';

const initialState: IAuthState = {
	access: '',
	refresh: '',
	loading: false,
	error: null,
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {},
	extraReducers: builder =>
		builder
			.addCase(authorize.pending, state => {
				state.loading = true;
				state.error = null;
			})
			.addCase(
				authorize.fulfilled,
				(state, action: PayloadAction<IAuthResponse>) => {
					state.access = action.payload.access;
					state.refresh = action.payload.refresh;

					localStorage.setItem('access', state.access);
					localStorage.setItem('refresh', state.refresh);

					state.loading = false;
					state.error = null;

          
          window.location.pathname = '/';
				},
			)
			.addCase(authorize.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload ?? null;
			}),
});

export const authReducer = authSlice.reducer;
